module.exports = __webpack_public_path__ + "img/icone-doguerias.465c54f1.svg";